import React, { FC, useState, useEffect, ReactElement } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import { ReactPlayerComponent } from "../../ReactPlayer/ReactPlayerComponent";
import { FileComponent } from "./FileComponent/FileComponent";
import { InstructionsComponent } from "./InstructionsComponent/InstructionsComponent";
import { TestComponent } from "./TestComponent/TestComponent";

interface TaskComponentProps {
  data: any;
  collapsed: any;
  setCollapsed: (collapsed: boolean) => void;
  isFinished?: boolean;
  lastLesson?: boolean;
}

export const TaskComponent: FC<TaskComponentProps> = ({
  lastLesson,
  isFinished,
  data,
  setCollapsed,
  collapsed,
}) => {
  const [step, setStep] = useState(1);
  const [stepsContent, setStepsContent] = useState<ReactElement[]>([]);
  useEffect(() => {
    setStep(1);
  }, [data]);
  useEffect(() => {
    const steps = [];
    if (data.video) {
      steps.push(
        <ReactPlayerComponent
          setCollapsed={setCollapsed}
          collapsed={collapsed}
          data={data}
        />
      );
    }
    steps.push(<InstructionsComponent data={data} />);
    if (data.file) {
      steps.push(<FileComponent data={data} />);
    }
    steps.push(<TestComponent data={data} />);

    setStepsContent(steps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, step]);

  const renderStepIndicator = () => {
    return stepsContent.map((_, index) => (
      <div
        key={index}
        className={
          step >= index + 1
            ? "step-indicator-item active"
            : "step-indicator-item"
        }></div>
    ));
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          minHeight: "478px",
          border: "1px solid rgba(1, 18, 36, 0.12)",
          display: "flex",
          padding: "32px",
          flexDirection: "column",
        }}>
        <div className="course-create-body">
          <div className="step-indicator">{renderStepIndicator()}</div>
          <div style={{ marginTop: "10px" }}>{stepsContent[step - 1]}</div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}>
            <Button
              className="close-modal-btn"
              variant="outlined"
              onClick={() => (step > 1 ? setStep(step - 1) : null)}
              disabled={step <= 1}>
              Назад
            </Button>
            <Button
              className="close-modal-btn"
              variant="contained"
              onClick={() => setStep(step + 1)}
              disabled={step >= stepsContent.length}>
              {isFinished && lastLesson
                ? "Завершить прохождение курса"
                : "Далее"}
            </Button>
          </Box>
          <Divider sx={{ pt: "10px" }} />
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 800,
            }}>
            {data.exercise_name}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              marginTop: "10px",
            }}>
            {data.description}
          </Typography>
        </div>
      </Box>
    </Box>
  );
};
